module.exports = __webpack_public_path__ + "static/media/img_4.dd146d3a.png";